import request from "../../../util/request"
import { APP_KEY, PHP_API_URL } from "../../../util/constants";
import Cookies from 'js-cookie'
export function getDataListRequest(namekey,callback){
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo',"get_teacher_list");
    formData.append('namekey', namekey);
    formData.append('username', Cookies.get('username'));;
    return request(PHP_API_URL+"/Teacher_studio/i", {
        method: "POST",
        body: formData
    }, callback);

}

export function getTeacherResRequest(teacherCode,callback){
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo',"get_teacher_res");
    formData.append('teacher_code', teacherCode);
    formData.append('username', Cookies.get('username'));;
    return request(PHP_API_URL+"/Teacher_studio/i", {
        method: "POST",
        body: formData
    }, callback);

}

export function getVideoPlayerAuthRequest(VideoId, callback) {
    let formData = new FormData();
    // formData.append('caozuo', "xuexi_shiti");
    formData.append('VideoId', VideoId);
    return request(PHP_API_URL+"/aliyun/getplayauth.php", {
        method: "POST",
        body: formData
    }, callback);
}

export function addTeacherClickNumRequest(teacherCode,callback){
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo',"add_teacher_click_num");
    formData.append('teacher_code', teacherCode);
    return request(PHP_API_URL+"/Teacher_studio/i", {
        method: "POST",
        body: formData
    }, callback);

}
export function addResClickNumRequest(resCode,resType,callback){
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo',"add_res_playordownlaod_num");
    formData.append('res_code', resCode);
    formData.append('res_type', resType);
    return request(PHP_API_URL+"/Teacher_studio/i", {
        method: "POST",
        body: formData
    }, callback);

}